import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

export const MedicalCommittee = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  return (
    <Stack>
      <Typography variant='body6'>
        {dictionary.steps.step4.info1_line1}
      </Typography>
      <Typography variant='body6'>
        {dictionary.steps.step4.info1_line2}
      </Typography>

      <Stack sx={{ m: '20px 0' }}>
        <Typography variant='body5'>
          {dictionary.steps.step4.info2_title}
        </Typography>
        <Typography variant='body6'>{dictionary.steps.step4.info2}</Typography>
        <Typography variant='body6'>{dictionary.steps.step4.note1}</Typography>
        <Typography variant='body6'>{dictionary.steps.step4.note2}</Typography>
      </Stack>

      <Stack sx={{ mb: '20px' }}>
        <Typography variant='body6'>{dictionary.steps.step4.note3}</Typography>
        <Typography variant='body6'>{dictionary.steps.step4.note4}</Typography>
      </Stack>

      <Typography variant='body5'>{dictionary.steps.step4.title}</Typography>
      <Typography variant='body6'>{dictionary.steps.step4.subTitle}</Typography>
      <ul style={{ marginTop: 0, listStylePosition: 'inside', padding: 0 }}>
        <Typography component={'li'} variant='body6'>
          - {dictionary.steps.step4.li1}
        </Typography>
        <Typography component={'li'} variant='body6'>
          - {dictionary.steps.step4.li2}
        </Typography>
      </ul>

      <Typography variant='body6'>{dictionary.steps.step4.info4}</Typography>
    </Stack>
  );
};
